import * as R from 'remeda';
import { Message } from '@rossum/api-client/shared';

const getMessageCategory = (msg: Message) => {
  if (msg.content.includes('Trigger condition')) return 'conditionErrors';
  if (msg.content.includes('Action')) return 'actionErrors';
  return 'otherErrors';
};

export const categorizeValidationMessages = (messages: Message[]) => {
  const grouped = R.groupBy(messages, getMessageCategory);

  return {
    conditionErrors: grouped.conditionErrors ?? [],
    actionErrors: grouped.actionErrors ?? [],
    otherErrors: grouped.otherErrors ?? [],
  };
};
